// config.ts
const API_BASE_URL = process.env.REACT_APP_API_USER_BASE_URL;

interface Config {
    baseURL: string;
}

const config: Config = {
    baseURL: `${API_BASE_URL}/api/v1`,
    // Other configuration options can go here
};

export default config;
